import { HttpClient } from "@angular/common/http";
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Injectable } from "@angular/core";
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { Observable } from "rxjs";
import { AttendantStatusDto, AttendantStatusByIdDto } from '../models/attendantStatus';

@Injectable({
  providedIn: 'root'
})
export class AttendantStatusService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}AttendantStatus`
  //private readonly apiUrl = `https://localhost:5009/company/AttendantStatus`

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  changeStatus(data: AttendantStatusDto): Observable<ResponseDefault<boolean>> {
    return this.http.post<ResponseDefault<boolean>>(`${this.apiUrl}/ChangeAttendantStatus`, data);
  }

  getStatus(): Observable<ResponseDefault<AttendantStatusDto>> {
    return this.http.get<ResponseDefault<AttendantStatusDto>>(this.apiUrl);
  }

  getStatusByIds(attendantIds: string[]): Observable<ResponseDefault<AttendantStatusByIdDto[]>> {
    return this.http.post<ResponseDefault<AttendantStatusByIdDto[]>>(`${this.apiUrl}/GetByIds`, { attendantIds });
  }
}
